import BD from './01 - BD.wav';
import HatClosed from './02 - Hat Closed.wav';
import HatClose from './03 - Hat Close.wav';
import HatOpen from './04 - Hat Open.wav';
import Ride from './05 - Ride.wav';
import Rim from './06 - Rim.wav';
import Snare from './07 - Snare.wav';
import Clap from './08 - Clap.wav';
import Crash from './09 - Crash.wav';
import Rim2 from './10 - Rim 2.wav';
import HiTom from './11 - Hi Tom.wav';
import MidTom from './12 - Mid Tom.wav';
import LoTom from './13 - Lo Tom.wav';
import Clap2 from './14 - Clap 2.wav';
import Ting from './15 - Ting.wav';
import Cowbell from './16 - Cowbell.wav';


export default {
    BD, HatClosed, HatClose, HatOpen, Clap, Clap2, Cowbell,
    Crash, HiTom, MidTom, LoTom, Ride, Rim, Rim2, Snare, Ting
}